document.querySelectorAll(".tab").forEach((tab) => {
	tab.addEventListener("click", function () {
		// Удаляем класс active у всех вкладок и контента
		document.querySelectorAll(".tab").forEach((t) => t.classList.remove("active"));
		document.querySelectorAll(".tab-content").forEach((c) => c.classList.remove("active"));

		// Удаляем класс active у всех roundings
		document.querySelectorAll(".roundings").forEach((rs) => rs.classList.remove("active"));

		// Добавляем активный класс к текущей вкладке
		this.classList.add("active");

		// Устанавливаем фон tabs-container
		document.querySelector(".tabs-container").style.background = window.getComputedStyle(this).background;

		// Показываем соответствующий контент
		document.getElementById("tab-" + this.dataset.tab).classList.add("active");

		// Добавляем класс active к roundings внутри активной вкладки
		this.querySelectorAll(".roundings").forEach((rs) => rs.classList.add("active"));

		const element = document.querySelector('[data-tab="2"]');
		switch (this.getAttribute("data-tab")) { //добавить полоску в зависимости от активной вкладки
			case "1":
				element.classList.add("border-tab-right");
				element.classList.remove("border-tab-left");
				document.querySelector(".tab-contents").style.borderRadius = "0 16px 16px 16px";
				break;
			case "2":
				element.classList.remove("border-tab-right");
				element.classList.remove("border-tab-left");
				document.querySelector(".tab-contents").style.borderRadius = "16px 16px 16px 16px";
				break;
			case "3":
				element.classList.add("border-tab-left");
				element.classList.remove("border-tab-right");
				document.querySelector(".tab-contents").style.borderRadius = "16px 0 16px 16px";
				break;
			default:
		}
	});
});

document.querySelectorAll(".people-ask-item-head").forEach((buttonHead) => {//добавить полоску в зависимости от активной вкладки для мобилок
	if (buttonHead.getAttribute("data-tab-head-id")) {
		buttonHead.addEventListener("click", function () {
			if(this.getAttribute("aria-expanded") == "false"){//если вкладка закрывается
				console.log("true");
				addBorderTop("1");
				addBorderTop("2");
				addBorderTop("3");
				return 0;
			}
			this.classList.remove("border-tab-top");
			switch (this.getAttribute("data-tab-head-id")) { //добавить контент, бордер внизу секции для мобилок
				case "1":
					addBorderTop("3");
					removeBorderTop("2");
					break;
				case "2":
					addBorderTop("1");
					removeBorderTop("3");
					break;
				case "3":
					addBorderTop("1");
					addBorderTop("2");
					break;
				default:
			}
			return 0;
		});
	}
});

function addBorderTop(dataTabHeadId) {
	const element = document.querySelector(`[data-tab-head-id="${dataTabHeadId}"]`);
	element.classList.add(`border-tab-top`);
}

function removeBorderTop(dataTabHeadId) {
	const element = document.querySelector(`[data-tab-head-id="${dataTabHeadId}"]`);
	element.classList.remove("border-tab-top");
}
